import { useState } from "react";
import { trackEvent } from "./analytics.js";

export default function CopyPrompt({ text = "", label = "Copy", copied = "Copied" }) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className="button"
      onClick={async (event) => {
        event.preventDefault();
        event.stopPropagation();
        try {
          await navigator.clipboard.writeText(text);
          trackEvent("mcp_copy_clicked", { label });
          setDone(true);
          window.setTimeout(() => setDone(false), 1600);
        } catch {
          // No-JS fallback (textarea / link) remains in the SSR markup.
        }
      }}
    >
      {done ? copied : label}
    </button>
  );
}
